import { render } from "./OrderDataPopper.vue?vue&type=template&id=03882b8a&scoped=true"
import script from "./OrderDataPopper.vue?vue&type=script&lang=js"
export * from "./OrderDataPopper.vue?vue&type=script&lang=js"

import "./OrderDataPopper.vue?vue&type=style&index=0&id=03882b8a&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03882b8a"]])

export default __exports__